/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './McpServerRegistryRpc';
import * as Queries from './McpServerRegistryRpc.dfc.new';
import type { AdditionalContextArgs } from './McpServerRegistryRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetMcpServerByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getMcpServerById', References.GetMcpServerByIdResponseType>
        : References.GetMcpServerByIdResponseType)
    | undefined;
};

export function useGetMcpServerByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVER_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServerById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServerByIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetMcpServerByIdQueryReturn<T>;
}

type UseGetMcpServerByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType,
    T extends true
      ? Record<'getMcpServerById', References.GetMcpServerByIdResponseType>
      : References.GetMcpServerByIdResponseType
  >;

export function useGetMcpServerByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVER_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServerById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServerByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServerByIdLazyQueryReturn<T>;
}

type UseGetMcpServerByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getMcpServerById', References.GetMcpServerByIdResponseType>
    : References.GetMcpServerByIdResponseType;
};

export function useGetMcpServerByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServerByIdResponseType>,
    References.GetMcpServerByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVER_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServerById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServerByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServerByIdSuspenseQueryReturn<T>;
}

type UseGetMcpServersQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetMcpServersResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getMcpServers', References.GetMcpServersResponseType>
        : References.GetMcpServersResponseType)
    | undefined;
};

export function useGetMcpServersQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_MCP_SERVERS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetMcpServersQueryReturn<T>;
}

type UseGetMcpServersLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServersResponseType>,
    {},
    T extends true
      ? Record<'getMcpServers', References.GetMcpServersResponseType>
      : References.GetMcpServersResponseType
  >;

export function useGetMcpServersLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersLazyQueryReturn<T>;
}

type UseGetMcpServersSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMcpServersResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getMcpServers', References.GetMcpServersResponseType>
    : References.GetMcpServersResponseType;
};

export function useGetMcpServersSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersSuspenseQueryReturn<T>;
}

type UseGetMcpServersByAuthenticatorIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
    References.GetMcpServersByAuthenticatorIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getMcpServersByAuthenticatorId',
            References.GetMcpServersByAuthenticatorIdResponseType
          >
        : References.GetMcpServersByAuthenticatorIdResponseType)
    | undefined;
};

export function useGetMcpServersByAuthenticatorIdQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
    References.GetMcpServersByAuthenticatorIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAuthenticatorIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAuthenticatorId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByAuthenticatorIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersByAuthenticatorIdQueryReturn<T>;
}

type UseGetMcpServersByAuthenticatorIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
    References.GetMcpServersByAuthenticatorIdRequestType,
    T extends true
      ? Record<
          'getMcpServersByAuthenticatorId',
          References.GetMcpServersByAuthenticatorIdResponseType
        >
      : References.GetMcpServersByAuthenticatorIdResponseType
  >;

export function useGetMcpServersByAuthenticatorIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
    References.GetMcpServersByAuthenticatorIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAuthenticatorIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAuthenticatorId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersByAuthenticatorIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersByAuthenticatorIdLazyQueryReturn<T>;
}

type UseGetMcpServersByAuthenticatorIdSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
      References.GetMcpServersByAuthenticatorIdRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getMcpServersByAuthenticatorId',
          References.GetMcpServersByAuthenticatorIdResponseType
        >
      : References.GetMcpServersByAuthenticatorIdResponseType;
  };

export function useGetMcpServersByAuthenticatorIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServersByAuthenticatorIdResponseType>,
    References.GetMcpServersByAuthenticatorIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAuthenticatorIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAuthenticatorId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByAuthenticatorIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersByAuthenticatorIdSuspenseQueryReturn<T>;
}

type UseGetMcpServerLogosQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getMcpServerLogos', References.GetMcpServerLogosResponseType>
        : References.GetMcpServerLogosResponseType)
    | undefined;
};

export function useGetMcpServerLogosQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerLogosQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVER_LOGOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServerLogos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServerLogosQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetMcpServerLogosQueryReturn<T>;
}

type UseGetMcpServerLogosLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType,
    T extends true
      ? Record<'getMcpServerLogos', References.GetMcpServerLogosResponseType>
      : References.GetMcpServerLogosResponseType
  >;

export function useGetMcpServerLogosLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerLogosLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVER_LOGOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServerLogos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServerLogosLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServerLogosLazyQueryReturn<T>;
}

type UseGetMcpServerLogosSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getMcpServerLogos', References.GetMcpServerLogosResponseType>
    : References.GetMcpServerLogosResponseType;
};

export function useGetMcpServerLogosSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServerLogosResponseType>,
    References.GetMcpServerLogosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServerLogosSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVER_LOGOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServerLogos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServerLogosSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServerLogosSuspenseQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
    References.GetMcpServersAvailableToPortalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getMcpServersAvailableToPortal',
            References.GetMcpServersAvailableToPortalResponseType
          >
        : References.GetMcpServersAvailableToPortalResponseType)
    | undefined;
};

export function useGetMcpServersAvailableToPortalQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
    References.GetMcpServersAvailableToPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersAvailableToPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersAvailableToPortalQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
    References.GetMcpServersAvailableToPortalRequestType,
    T extends true
      ? Record<
          'getMcpServersAvailableToPortal',
          References.GetMcpServersAvailableToPortalResponseType
        >
      : References.GetMcpServersAvailableToPortalResponseType
  >;

export function useGetMcpServersAvailableToPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
    References.GetMcpServersAvailableToPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersAvailableToPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersAvailableToPortalLazyQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
      References.GetMcpServersAvailableToPortalRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getMcpServersAvailableToPortal',
          References.GetMcpServersAvailableToPortalResponseType
        >
      : References.GetMcpServersAvailableToPortalResponseType;
  };

export function useGetMcpServersAvailableToPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServersAvailableToPortalResponseType>,
    References.GetMcpServersAvailableToPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersAvailableToPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersAvailableToPortalSuspenseQueryReturn<T>;
}

type UseGetMcpServersByAppIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getMcpServersByAppId',
            References.GetMcpServersByAppIdResponseType
          >
        : References.GetMcpServersByAppIdResponseType)
    | undefined;
};

export function useGetMcpServersByAppIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAppIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVERS_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByAppIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersByAppIdQueryReturn<T>;
}

type UseGetMcpServersByAppIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType,
    T extends true
      ? Record<
          'getMcpServersByAppId',
          References.GetMcpServersByAppIdResponseType
        >
      : References.GetMcpServersByAppIdResponseType
  >;

export function useGetMcpServersByAppIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAppIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersByAppIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersByAppIdLazyQueryReturn<T>;
}

type UseGetMcpServersByAppIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getMcpServersByAppId',
        References.GetMcpServersByAppIdResponseType
      >
    : References.GetMcpServersByAppIdResponseType;
};

export function useGetMcpServersByAppIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServersByAppIdResponseType>,
    References.GetMcpServersByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByAppIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServersByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByAppIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersByAppIdSuspenseQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalPaginatedQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.GetMcpServersAvailableToPortalPaginatedResponseType
      >,
      References.GetMcpServersAvailableToPortalPaginatedRequestType
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'getMcpServersAvailableToPortalPaginated',
              References.GetMcpServersAvailableToPortalPaginatedResponseType
            >
          : References.GetMcpServersAvailableToPortalPaginatedResponseType)
      | undefined;
  };

export function useGetMcpServersAvailableToPortalPaginatedQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetMcpServersAvailableToPortalPaginatedResponseType
    >,
    References.GetMcpServersAvailableToPortalPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalPaginatedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortalPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersAvailableToPortalPaginatedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersAvailableToPortalPaginatedQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalPaginatedLazyQueryReturn<
  T extends boolean,
> = LazyQueryResultTupleOverride<
  Record<
    'result',
    References.GetMcpServersAvailableToPortalPaginatedResponseType
  >,
  References.GetMcpServersAvailableToPortalPaginatedRequestType,
  T extends true
    ? Record<
        'getMcpServersAvailableToPortalPaginated',
        References.GetMcpServersAvailableToPortalPaginatedResponseType
      >
    : References.GetMcpServersAvailableToPortalPaginatedResponseType
>;

export function useGetMcpServersAvailableToPortalPaginatedLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetMcpServersAvailableToPortalPaginatedResponseType
    >,
    References.GetMcpServersAvailableToPortalPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalPaginatedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortalPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersAvailableToPortalPaginatedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersAvailableToPortalPaginatedLazyQueryReturn<T>;
}

type UseGetMcpServersAvailableToPortalPaginatedSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetMcpServersAvailableToPortalPaginatedResponseType
    >,
    References.GetMcpServersAvailableToPortalPaginatedRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getMcpServersAvailableToPortalPaginated',
        References.GetMcpServersAvailableToPortalPaginatedResponseType
      >
    : References.GetMcpServersAvailableToPortalPaginatedResponseType;
};

export function useGetMcpServersAvailableToPortalPaginatedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetMcpServersAvailableToPortalPaginatedResponseType
    >,
    References.GetMcpServersAvailableToPortalPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersAvailableToPortalPaginatedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServersAvailableToPortalPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersAvailableToPortalPaginatedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersAvailableToPortalPaginatedSuspenseQueryReturn<T>;
}
